import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import LineShieldCheckIcon from 'LuxKit/Icons/line/LineShieldCheckIcon'
import LineUserMdIcon from 'LuxKit/Icons/line/LineUserMdIcon'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import type { CarsValueProposition } from '../CarsValuePropositions'

function useAirportTransferValuePropositions(): Array<CarsValueProposition> {
  const intl = useIntl()

  return useMemo(() => [
    {
      id: 'price-lock',
      icon: LineShieldCheckIcon,
      title: intl.formatMessage({
        id: 'u7Psvg9Uv54yHrgqfPpz',
        defaultMessage: 'Price lock — no surprises',
        description: 'Price lock benefit title for airport transfers values section',
      }),
      description: intl.formatMessage({
        id: 'thOPhshb5Gt9Qsl1eWY-',
        defaultMessage: 'Taxes and free waiting time included: up to 45 mins for airport pick-ups and 15 mins for hotel pick-ups.',
        description: 'Price lock benefit description for airport transfers',
      }),
    },
    {
      id: 'insured-chauffeurs',
      icon: LineUserMdIcon,
      title: intl.formatMessage({
        id: '46_F1mE86DLxllWABXcq',
        defaultMessage: 'Insured chauffeurs',
        description: 'Insured chauffeurs benefit title for airport transfers',
      }),
      description: intl.formatMessage({
        id: 'DYXZ9EhyHKmbn3_Bmp2Y',
        defaultMessage: 'Travel with carefully selected, verified and insured drivers you can rely on.',
        description: 'Insured chauffeurs benefit description for airport transfers',
      }),
    },
    {
      id: 'flight-delayed',
      icon: LinePlaneDepartureIcon,
      title: intl.formatMessage({
        id: 'V3CMa6LWYltH1C3MlT6M',
        defaultMessage: "Flight delayed? We've got you",
        description: 'Flight delay benefit title for airport transfers values section',
      }),
      description: intl.formatMessage({
        id: 'ESwX3WYJS2Umr-8r3DaI',
        defaultMessage: 'Add your flight number at checkout. Your driver tracks your flight and adjusts your pickup for delays up to 3 hours.',
        description: 'Flight delay benefit description for airport transfers',
      }),
    },
    {
      id: 'support',
      icon: LinePhoneIcon,
      title: intl.formatMessage({
        id: 'WjzLpZFTWWDifPnRXF8F',
        defaultMessage: '24/7 support service',
        description: 'Support benefit title for airport transfers values section',
      }),
      description: intl.formatMessage({
        id: 'bWm3HjSZzceU2-qr7hKy',
        defaultMessage: 'Our support team is always on standby, available 24/7.',
        description: 'Support benefit description for airport transfers values section',
      }),
    },
  ], [intl])
}

export default useAirportTransferValuePropositions
